import React from 'react';
import BoxAcceptableSVG from 'assets/svg/box-acceptable.svg';
import BoxAcceptableOrangeSVG from 'assets/svg/box-acceptable-orange.svg';
import NoBoxAcceptableSVG from 'assets/svg/no-box-acceptable.svg';
import NoInventorySVG from 'assets/svg/no-inventory.svg';
import SuperSpeedSVG from 'assets/svg/super-speed-icon.svg';
export const BoxAcceptableOrange = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: BoxAcceptableOrangeSVG
  });
};
export const BoxAcceptable = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: BoxAcceptableSVG
  });
};
export const NoBoxAcceptable = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: NoBoxAcceptableSVG
  });
};
export const NoInventory = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: NoInventorySVG
  });
};
export const SuperSpeed = () => {
  return /*#__PURE__*/React.createElement("img", {
    src: SuperSpeedSVG
  });
};